import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SelectDialogData<T extends object> {
    title: string;
    options: T[];
    nameSelector?: string;
    infoText?: string;
}

@Component({
    selector: 'ceres-select-modal',
    templateUrl: './select-modal.component.html',
    styleUrls: ['./select-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectModalComponent<T extends object> {
    private readonly dialogRef = inject<MatDialogRef<SelectModalComponent<T>, T>>(MatDialogRef);
    readonly data = inject<SelectDialogData<T>>(MAT_DIALOG_DATA);

    public chooseOption(value: T) {
        this.dialogRef.close(value);
    }

    public cancel() {
        this.dialogRef.close();
    }
}
